// extracted by mini-css-extract-plugin
export default {"row":"viewMatches_row__0wed+","col":"viewMatches_col__xbbx8","card":"viewMatches_card__DGDfG"};